import { forwardRef, useMemo } from 'react';

import { Box, Indicator, Text } from '@mantine/core';
import type { DatePickerProps, DatePickerType } from '@mantine/dates';
import { DatePicker as MantineDatePicker } from '@mantine/dates';
import { dayjs } from '@ui';

import { useMergeClassNames } from '../../utils';
import dateInputClasses from '../dateinput/DateInput.module.css';

import { DatePickerOverrideClasses } from './DatePicker.style';

// type DatePickerComponentProps<T> = DatePickerProps<
//   T extends DatePickerType ? T : 'default'
// > & {
//   error?: string;
// };

const DatePickerComponent = <Type extends DatePickerType = 'default'>(
  props: DatePickerProps<Type> & {
    error?: string;
    clearable?: boolean;
  },
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  const { renderDay, size, classNames, error, ...rest } = props;

  const classes = useMemo(() => {
    return DatePickerOverrideClasses();
  }, []);

  const mergedClassNames = useMergeClassNames({
    classNames: [classes, classNames]
  });

  return (
    <>
      <MantineDatePicker<Type>
        {...rest}
        ref={ref}
        size={size}
        renderDay={(date) => {
          if (renderDay) {
            renderDay && renderDay(date);
          }
          const isToday = dayjs(date).isToday();
          return (
            <Indicator
              position="bottom-center"
              disabled={!isToday}
              classNames={{
                indicator: dateInputClasses.indicator
              }}
            >
              <Box>{date.getDate()}</Box>
            </Indicator>
          );
        }}
        classNames={mergedClassNames}
      />
      {error && (
        <Text c="red" fz={10} fw={500}>
          {error}
        </Text>
      )}
    </>
  );
};

const DatePicker = forwardRef(DatePickerComponent) as <
  T extends DatePickerType = 'default'
>(
  props: DatePickerProps<T> & { ref?: React.ForwardedRef<HTMLDivElement> }
) => React.ReactElement;

export { DatePicker };
